import React from "react";
import "./menu-superior.scss";
import { Card, CardHeader, CardBody, CardFooter, Row, Col } from "reactstrap";

class MenuSuperior extends React.Component {
  constructor() {
    super();
    this.onMenuClick = this.onMenuClick.bind(this);
  }
  render() {
    return (
      <div className="fixed-top menu-header">
        <div className="mb-3 mt-2 ">
          <div className="menu-background">
            <img className="ml-4 d-none d-md-block d-lg-block menu-header-logo" src="imagenes/portada/minam.png" />
            <img src="imagenes/portada/sinia-300x60.jpg" />
          </div>
        </div>
        <div className="d-flex  menu-superior">
          <div className="menu-background">
              <button
                className="menu-superior__menu-button"
                onClick={this.onMenuClick}
              >
                <svg height="24" viewBox="0 0 24 24" width="24">
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                </svg>
              </button>
              <a
                href="https://sinia.minam.gob.pe"
                className="nav-link"
                rel="noopener noreferrer"
              >
                <span>Inicio</span>
              </a>
              <a
                href="https://sinia.minam.gob.pe/acercade/que-es-sinia"
                className="nav-link d-none d-md-block d-lg-block"
                rel="noopener noreferrer"
              >
                <span>Acerca de</span>
              </a>
              <a
                href="https://sinia.minam.gob.pe/contenido/informacion"
                className="nav-link d-none d-md-block d-lg-block"
                rel="noopener noreferrer"
              >
                <span>Información</span>
              </a>
              <a
                href="https://sinia.minam.gob.pe/novedades"
                className="nav-link d-none d-md-block d-lg-block"
                rel="noopener noreferrer"
              >
                <span>Novedades</span>
              </a>
          </div>
        </div>
      </div>
    );
  }
  onMenuClick() {
    this.props.rootComponent.toggleMenu();
  }
}
export default MenuSuperior;
